import { Injectable, inject } from '@angular/core';
import { environment } from '../../environments/environment';
import { EnterpriseDto } from 'lib';
import { DomainDetectorService } from './domain-detector.service';

@Injectable({
    providedIn: 'root'
})
export class EnterpriseUserImpersonationService {
    private readonly domainDetectorService = inject(DomainDetectorService);


    private baseUrl = `${environment.keycloakConfig.url}`;

    getOrgAdminImpersonationUrl(ssoGuid: string, enterprise: EnterpriseDto): string {
        const orgAdminUrl = `${enterprise.alias}${enterprise.orgAdminDomain}`;
        const redirectUrl = `${environment.orgAdminProtocol}://${orgAdminUrl}`;
        return this.buildImpersonationUrl(ssoGuid, redirectUrl);
    }

    getOrganizationUserImpersonationUrl(ssoGuid: string, impersonationUrl: string, firmUserId?: string): string {
        const redirectUrl = `${environment.orgProtocol}://${impersonationUrl}`;
        return this.buildImpersonationUrl(ssoGuid, redirectUrl, firmUserId);
    }

    private buildImpersonationUrl(ssoGuid: string, redirectUrl: string, firmUserId?: string): string {
        const keycloakRealm = this.domainDetectorService.getDomainConfig().keycloakRealm;
        const base = `${this.baseUrl}/realms/${keycloakRealm}/impersonate/${ssoGuid}?redirect-url=${redirectUrl}`;
        return firmUserId ? `${base}&firmUserId=${encodeURIComponent(firmUserId)}` : base;
    }
}
